import {
  Address,
  PhoneNumber,
  EmploymentInfo,
  MaritalStatus,
} from './CommonTypes'

export enum OwnerType {
  AuthorizedAgent = 'AUTHORIZED_AGENT',
  AuthorizedMember = 'AUTHORIZED_MEMBER',
  AuthorizedOwner = 'AUTHORIZED_OWNER',
  Beneficiary = 'BENEFICIARY',
  Custodian = 'CUSTODIAN',
  EducationBeneficiary = 'EDUCATION_BENEFICIARY',
  EducationManager = 'EDUCATION_MANAGER',
  Executor = 'EXECUTOR',
  GuardianConservator = 'GUARDIAN_CONSERVATOR',
  InternalPowerOfAtty = 'INTERNAL_POWER_OF_ATTY',
  InitialDepositor = 'INITIAL_DEPOSITOR',
  JointOwner = 'JOINT_OWNER',
  MinorOwner = 'MINOR_OWNER',
  Other = 'OTHER',
  PrimaryOwner = 'PRIMARY_OWNER',
  PowerOfAtty = 'POWER_OF_ATTY',
  SoleProprietor = 'SOLE_PROPRIETOR',
  TradingAuthority = 'TRADING_AUTHORITY',
  Treasurer = 'TREASURER',
  Trustee = 'TRUSTEE',
  TrustedContact = 'TRUSTED_CONTACT',
}

export enum TaxIdType {
  NotUsed = 'NOT_USED',
  SocialSecurityNumber = 'SOCIAL_SECURITY_NUMBER',
  TaxIdNumber = 'TAX_ID_NUMBER',
  SocialInsurance = 'SOCIAL_INSURANCE',
  IndividualTaxIdNumber = 'INDIVIDUAL_TAX_ID_NUMBER',
  QualifiedIntermediary = 'QUALIFIED_INTERMEDIARY',
  AdopteeTaxId = 'ADOPTEE_TAX_ID',
  MockSsn = 'MOCK_SSN',
  UserDefined = 'USER_DEFINED',
}

export const TaxIdTypeDisplay: {
  [key in TaxIdType]: string
} = {
  [TaxIdType.NotUsed]: 'Not Used',
  [TaxIdType.SocialSecurityNumber]: 'SSN',
  [TaxIdType.TaxIdNumber]: 'TIN',
  [TaxIdType.SocialInsurance]: 'Social Insurance',
  [TaxIdType.IndividualTaxIdNumber]: 'Individual TIN',
  [TaxIdType.QualifiedIntermediary]: 'Qualified Intermediary',
  [TaxIdType.AdopteeTaxId]: 'Adoptee Tax ID',
  [TaxIdType.MockSsn]: 'Mock SSN',
  [TaxIdType.UserDefined]: 'User Defined',
}

export interface AccountOwner {
  givenName: string
  familyName: string
  entityName: string
  ownerType: OwnerType
  dateOfBirth: string
  citizenshipCountry: string
  homeAddress: Address
  mailingAddress: Address
  phoneNumbers: PhoneNumber[]
  emailAddresses: string[]
  maritalStatus: MaritalStatus
  numDependents: number
  employment: EmploymentInfo
  isDeceased: boolean
  taxId: string
  taxIdType: TaxIdType
  fullTaxIdToken: string
}
